<template>
    <div class="dark-form">
        <div class="dark-form__inner">
            <h1 class="dark-form__title h1">
                Register
            </h1>
            <transition name="slide-down">
                <div class="dark-form__error" v-if="registrationError">
                    Something went wrong during registration. Please try again.
                </div>
            </transition>
            <transition name="slide-down">
                <div class="dark-form__success" v-if="registrationSuccess">
                    You have been successfully registered! 🎉
                    <router-link
                        class="dark-form__success__link"
                        :to="{ name: 'Login' }"
                    >
                        Go to login <i class="el-icon-right"></i>
                    </router-link>
                </div>
                <el-form
                    class="form dark-form__form"
                    ref="form"
                    :model="formData"
                    :rules="validationRules"
                    v-else
                >
                    <el-form-item
                        label="First name"
                        class="space-bottom--medium"
                        prop="first_name"
                    >
                        <el-input
                            v-model="formData.first_name"
                            @input="touchForm"
                            class="dark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Last name"
                        class="space-bottom--medium"
                        prop="last_name"
                    >
                        <el-input
                            v-model="formData.last_name"
                            @input="touchForm"
                            class="dark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="E-Mail"
                        class="space-bottom--medium"
                        prop="email"
                    >
                        <el-input
                            type="email"
                            v-model="formData.email"
                            @input="touchForm"
                            class="dark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Password"
                        class="space-bottom--medium"
                        prop="password"
                    >
                        <el-input
                            v-model="formData.password"
                            @input="touchForm"
                            type="password"
                            class="dark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Confirm password"
                        class="space-bottom"
                        prop="password_confirmation"
                    >
                        <el-input
                            v-model="formData.password_confirmation"
                            @input="touchForm"
                            type="password"
                            class="dark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <Button
                            size="big"
                            @click="submitForm"
                            type="white-border"
                            >Register</Button
                        >
                    </el-form-item>
                </el-form>
            </transition>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import Button from '@/components/Button.vue';

export default {
    components: {
        Button,
    },
    data() {
        const validatePasswordConfirmation = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please confirm your password'));
            } else if (value !== this.formData.password) {
                callback(new Error('Passwords are not the same'));
            } else {
                callback();
            }
        };
        const validatePasswordStrength = (rule, value, callback) => {
            const isStrongEnough = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{10,}$/.test(
                value,
            );
            if (!isStrongEnough && value !== '') {
                callback(
                    new Error(
                        'The password has to be at least 10 characters long and contain an upper- and lowercase letter, a digit and a special character.',
                    ),
                );
            } else {
                callback();
            }
        };

        return {
            formTouched: false,
            registrationSuccess: false,
            registrationError: false,
            formData: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                code: this.$route.query.code,
            },
            validationRules: {
                first_name: [
                    {
                        required: true,
                        message: 'Please enter your first name',
                        trigger: 'blur',
                    },
                ],
                last_name: [
                    {
                        required: true,
                        message: 'Please enter your last name',
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: 'Please enter your e-mail address',
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: 'Please input a valid email address.',
                        trigger: ['blur', 'change'],
                    },
                ],
                password: [
                    {
                        required: true,
                        message: 'Please enter a password',
                        trigger: 'blur',
                    },
                    { validator: validatePasswordStrength, trigger: 'blur' },
                ],
                password_confirmation: [
                    {
                        required: true,
                        message: 'Please confirm your password',
                        trigger: 'blur',
                    },
                    {
                        validator: validatePasswordConfirmation,
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    mounted() {},
    methods: {
        async sendForm() {
            try {
                const response = await api.user.register(this.formData);
                if (response) {
                    this.registrationSuccess = true;
                }
            } catch (error) {
                console.error(error);
                this.registrationError = true;
            }
        },
        touchForm() {
            this.formTouched = true;
        },
        submitForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.formTouched = false;
                    this.registrationError = false;
                    this.registrationSuccess = false;
                    this.sendForm();
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
